import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 lg:flex lg:flex-col pt-16 lg:pt-0 justify-center" }

import VLazyImage from "v-lazy-image";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

//@ts-ignore

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VLazyImage), {
      src: "home.png",
      "src-placeholder": "home-small.png",
      class: "w-full lg:w-3/4 mx-auto max-h-screen lg:py-10"
    })
  ]))
}
}

})